import React from 'react';
import { Markup } from 'interweave';
import { chunk } from 'lodash-es';

import styles from '../index.scss';
import { statsProps } from '../../../../props/feed-prop-types';

const ActivityStats = ({ stats }) => (
  <div className={styles.statContainer}>
    <ul className={styles.listStats}>
      {// Chunk stats into pairs to extract label and value
      // stats = [{key='stat_one', value='10 mi'},{key='stat_one_subtitle', value='Distance'},
      //          {key='stat_two', value='7 min'},{key='stat_time_subtitle', value='Time'}]
      // chunks into => [[{key='stat_one', value='10 mi'},{key='stat_one_subtitle', value='Distance'}],
      //                 [{key='stat_two', value='7 min'},{key='stat_time_subtitle', value='Time'}]]
      chunk(stats, 2).map((stat) => {
        return (
          <li key={`${stat.key}-${stat[1].value}`} data-testid="stat">
            <div className={styles.stat}>
              <div className={styles.statSubtext} data-testid="stat_label">
                {stat[1].value}
              </div>
              <b className={styles.statText} data-testid="stat_value">
                <Markup noWrap={true} content={stat[0].value} />
              </b>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

ActivityStats.propTypes = {
  stats: statsProps
};

ActivityStats.defaultProps = {
  stats: []
};

export default ActivityStats;
